import { Global } from '@emotion/react';

type Face = {
    family: string;
    file: string;
    weight: number;
    style?: 'italic';
};

// One entry per @font-face, under each font's own family name (`Colfax`,
// `Ubuntu Mono`): the same names the theme tokens and @ionq/ui's
// --font-sans/--font-mono reference.
const FACES: Face[] = [
    { family: 'Colfax', file: 'Colfax-Light', weight: 300 },
    { family: 'Colfax', file: 'Colfax-Regular', weight: 400 },
    { family: 'Colfax', file: 'Colfax-Medium', weight: 500 },
    { family: 'Colfax', file: 'Colfax-Bold', weight: 600 },
    // Bold doubles as 700 so `fontWeight: 'bold'` matches an exact face
    // instead of nearest-matching from 600.
    { family: 'Colfax', file: 'Colfax-Bold', weight: 700 },
    { family: 'Colfax', file: 'Colfax-Black', weight: 900 },
    { family: 'Ubuntu Mono', file: 'UbuntuMono-Regular', weight: 400 },
    { family: 'Ubuntu Mono', file: 'UbuntuMono-Bold', weight: 700 },
    {
        family: 'Ubuntu Mono',
        file: 'UbuntuMono-Italic',
        weight: 400,
        style: 'italic',
    },
    {
        family: 'Ubuntu Mono',
        file: 'UbuntuMono-BoldItalic',
        weight: 700,
        style: 'italic',
    },
];

const fontFaces = FACES.map(
    ({ family, file, weight, style = 'normal' }) => `
    @font-face {
        font-family: '${family}';
        src: url("/fonts/${file}.woff2") format('woff2'), url("/fonts/${file}.woff") format('woff');
        font-weight: ${weight};
        font-style: ${style};
        font-display: swap;
    }`,
).join('\n');

const Fonts = () => <Global styles={fontFaces} />;

export default Fonts;
